"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const DictionaryEvidence = __importStar(require("../../../composite/evidence/dictionary-evidence/dictionary-evidence"));
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const export_api_1 = require("../export-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { columnOrder, columnName, columnValidFrom, columnValidTo, columnActive, columnCode, columnCreated, columnCreatedBy, columnUpdated, columnUpdatedBy, } = DictionaryEvidence.useDictionaryColumns();
    return [
        columnName,
        {
            datakey: 'label',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_LABEL',
                defaultMessage: 'Označení',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'dataProvider',
            sortkey: 'dataProvider.name',
            filterkey: 'dataProvider.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_DATA_PROVIDER',
                defaultMessage: 'Zdroj dat',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportDataProviders),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportDataProviders),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'designProvider',
            sortkey: 'designProvider.name',
            filterkey: 'designProvider.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_DESIGN_PROVIDER',
                defaultMessage: 'Zdroj designu',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportDesignProviders),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportDesignProviders),
            sortable: true,
            filterable: true,
        },
        columnActive,
        columnValidFrom,
        columnValidTo,
        columnCode,
        columnOrder,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=export-templates-colums.js.map